import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import {
    Autocomplete,
    Button,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { t } from "i18next";
import { useWatch } from "react-hook-form";
import { ClientPassportButton } from "../../../components/buttons/ClientPassportButton";
import { AddConnectedCompanyPerson } from "../../../components/dialog/AddConnectedCompanyPerson/AddConnectedCompanyPerson";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { EditConnectedPersonDialog } from "../../PersonRepositoryPage/EditConnectedPersonDialog";
import { ConectedPersonsTable } from "./tables/ConectedPersonsTable";


export function CompanyAddConnectedPersons(props) {
    const {
        openDialog: openAddConnectedCompanyPerson,
        closeDialog: closeAddConnectedCompanyPerson,
    } = useDialogBetter();
    const { openDialog: openEditPersonDialog } = useDialogBetter();
    const { openDialog: openNestedPassport } = useDialogBetter();

    const connectedPersons = useWatch({
        control: props.control,
        name: "connectedPersons",
        defaultValue: [],
    });

    return (
        <Grid container direction={"row"} justifyContent={"start"} alignItems={"baseline"} gap={2}>
            <Grid
                container
                direction={"row"}
                justifyContent={"start"}
                alignItems={"baseline"}
                gap={2}
            >
                <Grid item>
                    <Typography variant={"body1"} sx={{ mt: 1, fontWeight: "medium" }}>
                        {t("clients.passportDialogCompany.connectedPersons")}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        endIcon={<AddCircleOutlineIcon />}
                        onClick={() => {
                            openAddConnectedCompanyPerson({
                                Component: AddConnectedCompanyPerson,
                                componentProps: {
                                    excludedCustomerIds: props.excludedCustomerIds,
                                    onSubmit: (data) => {
                                        props.setValue("connectedPersons", [
                                            ...connectedPersons,
                                            data,
                                        ]);
                                        closeAddConnectedCompanyPerson();
                                    },
                                },
                            });
                        }}
                    >
                        Powiąż osobę
                    </Button>
                </Grid>
            </Grid>
            <Grid
                container
                direction={"row"}
                justifyContent={"start"}
                alignItems={"center"}
                gap={1}
            >
                <Grid item xs={12} >
                    <ConectedPersonsTable data={connectedPersons}/>
                </Grid>
                
                {/* <Autocomplete
                    fullWidth
                    sx={{
                        "& .MuiAutocomplete-popupIndicatorOpen": {
                            transform: "none",
                        },
                    }}
                    size="small"
                    options={connectedPersons}
                    autoHighlight
                    popupIcon={<SearchIcon />}
                    getOptionLabel={(option) =>
                        `${option.name || "-"} ${option.surname || "-"} ${
                            t(`company.roles.${option.companyFunction}`) || "-"
                        } ${option.phone || "-"} ${option.email || "-"}`
                    }
                    renderOption={(renderProps, option, { index }) => {
                        return (
                            <>
                                <Grid
                                    key={renderProps.key}
                                    container
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    spacing={1}
                                    alignItems={"center"}
                                    sx={{ px: 2, textWrap: "nowrap" }}
                                    flexWrap={"nowrap"}
                                >
                                    <Grid direction={"column"} item>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                            }}
                                        >
                                            {t("clients.passportDialogCompany.firstName")}
                                        </Typography>
                                        <Typography variant="body1">
                                            {option.name || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid direction={"column"} item>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                            }}
                                        >
                                            {t("clients.passportDialogCompany.lastName")}
                                        </Typography>
                                        <Typography variant="body1">
                                            {option.surname || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid direction={"column"} item>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                            }}
                                        >
                                            {t("clients.passportDialogCompany.function")}
                                        </Typography>
                                        <Typography variant="body1">
                                            {t(`company.roles.${option.companyFunction}`) || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid direction={"column"} item>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                            }}
                                        >
                                            {t("clients.passportDialogCompany.phone")}
                                        </Typography>
                                        <Typography variant="body1">
                                            {option.phone || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid direction={"column"} item>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                            }}
                                        >
                                            {t("clients.passportDialogCompany.email")}
                                        </Typography>
                                        <Typography variant="body1">
                                            {option.email || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {option.existingClientId && (
                                            <ClientPassportButton
                                                clientId={option.existingClientId}
                                                clientType="customer"
                                                color="primary"
                                            />
                                        )}
                                        {!option.existingClientId &&
                                            option.exisitngClientPersonId && (
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        openEditPersonDialog({
                                                            Component: EditConnectedPersonDialog,
                                                            componentProps: {
                                                                personId:
                                                                    option.exisitngClientPersonId,
                                                            },
                                                        });
                                                    }}
                                                >
                                                    <InfoIcon />
                                                </IconButton>
                                            )}
                                    </Grid>
                                </Grid>
                                {index !== connectedPersons.length - 1 && (
                                    <Divider sx={{ my: 1, mx: 2 }} />
                                )}
                            </>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("clients.passportDialogCompany.addedConnectedPersons")}
                        />
                    )}
                /> */}

                

            </Grid>
        </Grid>
    );
}
